import React from 'react';
import { MessageCircle, Phone, Image } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { contactData, whatsappMessages } from '../utils/mock';

export const WhatsAppActions = ({ variant = 'full' }) => {
  const phoneNumber = contactData.phone.replace(/\s+/g, '');

  const actions = [
    {
      icon: MessageCircle,
      label: 'General Inquiry',
      message: whatsappMessages.general,
      color: 'from-green-500 to-green-600'
    },
    {
      icon: Phone,
      label: 'Quick Consultation',
      message: whatsappMessages.consultation,
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      icon: Image,
      label: 'Discuss Portfolio',
      message: whatsappMessages.portfolio,
      color: 'from-teal-500 to-teal-600'
    }
  ];

  const handleWhatsAppClick = (message) => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  if (variant === 'compact') {
    return (
      <div className="flex flex-wrap gap-3">
        {actions.map((action, index) => {
          const IconComponent = action.icon;
          return (
            <Button
              key={index}
              onClick={() => handleWhatsAppClick(action.message)}
              className={`bg-gradient-to-r ${action.color} hover:opacity-90 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group`}
            >
              <IconComponent className="h-4 w-4 mr-2" />
              {action.label}
            </Button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-3 gap-6">
      {actions.map((action, index) => {
        const IconComponent = action.icon;
        return (
          <Card
            key={index}
            onClick={() => handleWhatsAppClick(action.message)}
            className="group cursor-pointer border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white rounded-2xl"
          >
            <CardContent className="p-6 text-center">
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r ${action.color} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <IconComponent className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {action.label}
              </h3>
              <p className="text-sm text-gray-600">
                Start a WhatsApp conversation
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
